export default {
  DESTROY: 'LKGridInstance/DESTROY',

  gridState: {
    REDUCE_FILTER_MODEL: 'LKGridInstance/gridState/REDUCE_FILTER_MODEL',
    REMOVE_FILTER_COLUMN: 'LKGridInstance/gridState/REMOVE_FILTER_COLUMN',
  },

  MAKE_DEFAULT_SELECTED_TRUE: 'LKGridInstance/MAKE_DEFAULT_SELECTED_TRUE',

  selectedRow: {
    SELECT: 'LKGridInstance/selectedRow/SELECT',
    DESELECT: 'LKGridInstance/selectedRow/DESELECT',
  },

  sortedColumn: {
    SORT_ASC: 'LKGridInstance/sortedColumn/SORT_ASC',
    SORT_DESC: 'LKGridInstance/sortedColumn/SORT_DESC',
    SORT_NONE: 'LKGridInstance/sortedColumn/SORT_NONE',
  },
}
